<template>
  <div style="background-color: #f0f0f0">
    <div class="footer">
      <span>主管部门:{{ cityDetail.cityName }}农业农村局</span>
      <span>监督部门:{{ cityDetail.cityName }}纪委监委</span>
      <span>技术单位:河南晟宇信息技术有限公司</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
}
</script>

<style scoped>
.footer {
  height: 44px;
  width: 60%;
  margin: 0 auto;
  background-color: #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer > span {
  font-family: Source Han Sans;
  flex: 1;
  text-align: center;
  opacity: 1;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #363636;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
}
.footer > span:last-child {
  border-right: none;
}
</style>
